// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-card p{font-family:var(--font-roboto);font-size:16px;font-style:normal;line-height:24px;font-weight:300}`, "",{"version":3,"sources":["webpack://./overrides/app/components/category-grid/category-card.scss"],"names":[],"mappings":"AACA,iBACI,8BAAA,CACA,cAAA,CACA,iBAAA,CACA,gBAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
